import React from "react";
import Service from "../../../../util/Service";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, List, ListItem, ListItemIcon, ListItemText, Typography, styled } from "@mui/material";
import { Task, ViewKanban } from "@mui/icons-material";

const IB = styled(IconButton)(({ theme }) => ({
    borderRadius: 0,
}));

export default function KanbansProjeto(props) {
    const { marcado, refDiv, action } = props;
    const [projetos, setProjetos] = React.useState();
    const [projetosF, setProjetosF] = React.useState();
    const [open, setOpen] = React.useState(false);
    React.useEffect(()=>{
        if( open){
            bustaTodosProjetos();
        }
    },[open])
    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };
    function handleTask(row) {
        if (marcado) {
            let el = marcado;
            if (!marcado.tagName) {
                el = marcado.parentNode;
            }
            console.log(el);
            console.log(el.tagName, el.innerHTML.length);
            el.id = 'conteudoKanbanProjeto';
            if (el.innerHTML || el.innerHTML.length === 0) el.innerHTML = "<p style='background: var(--pd-primary-main); color:#fff; width:100%'>CONTEUDO KANBAN PROJETO</p>"

            const div = document.createElement("div");
            div.innerHTML = '<div style="padding:2px"><br></div>';
            el.after(div);
            const html = refDiv.current.innerHTML;

            const dado = {
                idProjeto: row.id,
                code: html,
            }
            Service.POST("/api/security/model/montaCodigoKanbans/"+row.id, dado).then(r => {
                if (r.success) {
                    refDiv.current.innerHTML = r.dado;
                    //handleClose();
                    if (action) action();
                } else {
                    
                }
            })
        }
    }
    function handleEscolheProjeto(row){
        console.log( row );
        handleTask(row)
        handleClose();
    }
    function bustaTodosProjetos() {
        Service.GET('/api/projeto/buscaTodosLimitado').then(r => {
            setProjetos(r);
            setProjetosF(r);
        }).catch(e => {
            console.error(e);
        })
    }
    return (
        <React.Fragment>
            <ListItem sx={{ cursor: 'pointer' }} onClick={handleClickOpen}>
                <ListItemIcon >
                    <IB size="small">
                        <ViewKanban />
                    </IB>
                </ListItemIcon>
                <ListItemText primary="Kanban" secondary="Quadros do projeto" />
            </ListItem>

            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="escolha-projeto"
                aria-describedby="lista-tarefa"
                fullWidth
                maxWidth='sm'
            >
                <DialogTitle id="escolha-projeto">
                    Quadros - Escolha Projeto
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="lista-tarefa">
                        Lista de Kanban do projeto:
                    </DialogContentText>
                    <List dense={true}
                        sx={{
                            // width: 360, maxWidth: 360, bgcolor: 'background.paper',
                            overflow: 'auto',
                            maxHeight: 450,
                        }}
                    >

                        {projetosF && projetosF.map((row, id) =>
                            <ListItem
                                alignItems="flex-start" key={"list-popover-proj-" + id}
                            >
                                <ListItemText onClick={() => handleEscolheProjeto(row)}
                                    sx={{ cursor: 'pointer' }}
                                    primary={<React.Fragment><b>Projeto: </b>{row.nome}</React.Fragment>}
                                    secondary={
                                        <React.Fragment>
                                            <Typography
                                                component="span"
                                                variant="body2"
                                                sx={{ color: 'text.primary', display: 'inline' }}
                                            >
                                                {row.descricao}
                                            </Typography>
                                        </React.Fragment>
                                    }
                                />
                            </ListItem>
                        )}
                    </List>

                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Cancela</Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    )
}